import React from "react";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";
import "./Principles.scss";

const PrincipleCard = ({ icon, title, desc }) => {
  const [ref, isInView] = useIntersectionObserver();

  return (
    <div
      ref={ref}
      className={`principle-card fade-in-section ${isInView ? "in-view" : ""}`}
    >
      <div className="card-icon">{icon}</div>
      <h4>{title}</h4>
      <p>{desc}</p>
    </div>
  );
};

const Principles = () => {
  return (
    <section className="principles section-padding">
      <div className="principles-inner max-width">
        <div className="principles-header">
          <h2>
            Proof over <span>Promises</span>
          </h2>
          <p className="subtitle">
            We don't hype results — we engineer growth with a system that compounds.
          </p>
        </div>

        <div className="principles-grid">
          <PrincipleCard
            icon="📊"
            title="Track right"
            desc="GA4, pixels, calls, forms, and WhatsApp attribution — implemented correctly."
          />
          <PrincipleCard
            icon="🎯"
            title="Run smart"
            desc="Google Ads for demand capture, Meta for scale and retargeting."
          />
          <PrincipleCard
            icon="📈"
            title="Improve weekly"
            desc="Relentless experimentation, optimization, and budget refinement."
          />
          <PrincipleCard
            icon="📋"
            title="Report clearly"
            desc="Insights, actions, and next steps — no fluff, no confusion."
          />
          <PrincipleCard
            icon="🚀"
            title="Start with a pilot"
            desc="Validate performance first, then scale with confidence."
          />
        </div>

        <div className="non-negotiables-section">
          <h3 className="non-neg-title">Our non-negotiables</h3>

          <div className="non-negotiables">
            <span>
              <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              No black-box reporting
            </span>
            <span>
              <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              Clear KPI ownership (CPL, CVR, lead quality)
            </span>
            <span>
              <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              Weekly structured experiments
            </span>
            <span>
              <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              Spend only on measurable actions
            </span>
            <span>
              <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              Decisions backed by data — not opinions
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Principles;